// Part of accountingPages, split by screen to keep files short; ../accountingPages.ts merges the parts.
// Keys sit directly under accountingPages, in sub-objects whose names no other part uses.
export const en = {
  // Write off invoices (A9): the keys writeOffPage lacks.
  writeOffInvoices: {
    colDate: 'Date',
    colInvoice: 'Invoice',
    colAmount: 'Amount',
    colAccount: 'Account',
    colReason: 'Reason',
    colStatus: 'Status',
    colAction: 'Action',
    returnPeriod: 'Return {{period}}',
    posted: 'Posted',
    undone: 'Undone',
    undo: 'Undo',
    undoTitle: 'Undo the write-off of {{number}}?',
    undoDescription:
      'The write-off entry is reversed on its own date, the invoice is open again and any VAT relief adjustment is removed from the VAT return.',
    undoConfirm: 'Undo write-off',
  },
  // Management reports list (A10): toasts whose English differs from managementReports.
  managementReportsList: {
    created: '"{{name}}" created.',
    deleted: '"{{name}}" deleted.',
  },
  // Screen-reader text of the copied sidebar component.
  sidebar: {
    title: 'Sidebar',
    description: 'Displays the mobile sidebar.',
    toggle: 'Toggle Sidebar',
  },
};

export const ar = {
  writeOffInvoices: {
    colDate: 'التاريخ',
    colInvoice: 'الفاتورة',
    colAmount: 'المبلغ',
    colAccount: 'الحساب',
    colReason: 'السبب',
    colStatus: 'الحالة',
    colAction: 'الإجراء',
    returnPeriod: 'الإقرار {{period}}',
    posted: 'مُرحَّل',
    undone: 'تم التراجع',
    undo: 'تراجع',
    undoTitle: 'التراجع عن شطب {{number}}؟',
    undoDescription:
      'يُعكس قيد الشطب في تاريخه نفسه، وتعود الفاتورة مفتوحة، وتُحذف أي تسوية لاسترداد ضريبة القيمة المضافة من الإقرار الضريبي.',
    undoConfirm: 'التراجع عن الشطب',
  },
  managementReportsList: {
    created: 'تم إنشاء «{{name}}».',
    deleted: 'تم حذف «{{name}}».',
  },
  sidebar: {
    title: 'الشريط الجانبي',
    description: 'يعرض الشريط الجانبي على الجوال.',
    toggle: 'إظهار الشريط الجانبي أو إخفاؤه',
  },
};
